var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(['admin', 'super_admin', 'director'].includes(_vm.user.role.name))?_c('admin-home'):_vm._e(),(['student'].includes(_vm.user.role.name))?_c('student-home'):_vm._e(),(['coordinator'].includes(_vm.user.role.name))?_c('coordinator-home'):_vm._e(),(['tech_secretary'].includes(_vm.user.role.name))?_c('tech-secretary-home'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }